import {MenuItem} from "./menu-item";
import {LinkConfigEntry, MenuConfigEntry} from "../../base-api";
import {TranslateService} from "@ngx-translate/core";

export class MenuTreeItem {

  children: Array<MenuTreeItem>;
  content: MenuItem;
  order?: number;
  deactivated?: boolean;

  public static readonly orderCompare = (n1, n2) => n1.order - n2.order;

  constructor(children: Array<MenuTreeItem>, content: MenuItem, order?: number, deactivated?: boolean) {
    this.children = children;
    this.content = content;
    this.order = order;
    this.deactivated = deactivated;
  }

  get activatedChildren(): Array<MenuTreeItem> {
    return this.children.filter(value => !value.deactivated);
  }

  replaceChild(element: MenuConfigEntry.ElementEnum, subMenu: MenuTreeItem) {
    if (subMenu && subMenu.children && subMenu.children.length > 0) {
      this.removeChild(element);
      this.children.push(subMenu);
      this.children.sort(MenuTreeItem.orderCompare);
    }
  }

  removeChild(element: MenuConfigEntry.ElementEnum) {
    if (this.children && this.children.length > 0) {
      const existing = this.children.find(m => m.content.element === element);
      if (existing) {
        this.children.splice(this.children.indexOf(existing), 1);
      }
    }
  }
}

export class UnterstuetzungMenuTreeItem extends MenuTreeItem {

  private static isExternalLink(url: string) {
    return url.indexOf('://') !== -1;
  }

  constructor(entry: LinkConfigEntry, private translateService: TranslateService) {
    super([], <MenuItem>{
      text: translateService.currentLang === "fr" ? entry.linkTextFr : entry.linkTextDe,
      element: null
    }, entry.position);
    this.updateLink(translateService.currentLang, entry);
    this.translateService.onLangChange.subscribe(l => this.updateLink(l.lang, entry));
  }

  private updateLink(currentLang, entry: LinkConfigEntry) {
    this.content.text = currentLang === "fr" && entry.linkTextFr ? entry.linkTextFr : entry.linkTextDe;
    const link = currentLang === "fr" ? entry.linkFr : entry.linkDe;
    if (UnterstuetzungMenuTreeItem.isExternalLink(link)) {
      this.content.href = link;
      this.content.target = "_blank";
      return;
    }
    this.content.link = link;
  }
}
